import * as S from './styles';
import { IStarsProps } from './types';

export const RatingStars: React.FC<IStarsProps> = ({ rating }) => (
  <S.Stars style={{ ['--rating' as string]: rating.toString() }} />
);
